// frontend/src/components/Dashboard/Dashboard.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Dashboard.css';

export const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>📊 Visão Geral</h1>
        <div className="user-info">
          <span>👋 {user?.name}</span>
          <button onClick={handleLogout} className="logout-button">
            Sair
          </button>
        </div>
      </header>

      <div className="dashboard-content">
        <div className="welcome-card">
          <h2>Bem-vindo, {user?.name}!</h2>
          <p>Você está autenticado com sucesso.</p>
          <div className="user-details">
            <div className="detail-item">
              <span className="label">Email:</span>
              <span className="value">{user?.email}</span>
            </div>
            {user?.company && (
              <div className="detail-item">
                <span className="label">Empresa:</span>
                <span className="value">{user?.company}</span>
              </div>
            )}
            <div className="detail-item">
              <span className="label">Logins:</span>
              <span className="value">{user?.loginCount || 0}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;